module.exports = __webpack_public_path__ + "static/media/story_15.884c2f83.jpg";